import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Alert } from '@surfline/quiver-react';
import classNames from 'classnames';
import { Lock, NewTab } from '../Icons';
import en from '../../international/translations/en';
import { trackPerkEvents } from '../../utils/trackPerkEvents';

const getButtonClass = (eligible, planType, isCodeAvailable) => classNames({
  'perk-button': true,
  'perk-button--premium': eligible && isCodeAvailable,
  'perk-button--free': !eligible && planType === 'free',
  'perk-button--monthly': !eligible && planType === 'monthly',
  'perk-button--code-unavailable': (eligible && !isCodeAvailable) || (!eligible && planType !== 'free'),
});

const getButtonText = (planType, eligible, isCodeAvailable) => {
  if (!eligible && planType === 'free') return 'UNLOCK DEAL';
  if (eligible && !isCodeAvailable) return 'COMING SOON';
  return 'GET CODE';
};

class Perk extends Component {
  constructor(props) {
    super(props);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }
  handleButtonClick(perkId = null, eligible, planType) {
    const { fetchPerkCode, perk } = this.props;
    if (!eligible) {
      const { name: perkName } = perk;
      trackPerkEvents(planType, { perkId, perkName });
    }
    if (!eligible && planType === 'free') return window.location.assign(en.perks.freeRedirectUrl);
    if (!eligible && planType === 'monthly') return window.location.assign(en.perks.monthlyRedirectUrl);
    return fetchPerkCode(perkId);
  }
  render() {
    const {
      perk, planType, selectedPerks, selectedPerk, submitting, error, subscription
    } = this.props;
    const {
      eligible,
      isCodeAvailable,
      _id: perkId,
      lastRequestedCode,
      partnerUrl,
      bgDesktopImgPath,
      logoImgPath,
      discountText,
      name,
      description,
      freeDescription
    } = perk;
    const onTrial = subscription && subscription.onTrial;
    const thisPerk = selectedPerks.find(({ perkId: aPerk }) => aPerk === perkId);
    const activePerkId = thisPerk ? thisPerk.perkId : null;
    const perkCode = thisPerk ? thisPerk.perkCode : null;
    const showLoading = submitting && perkId === selectedPerk;
    const showError = error && perkId === selectedPerk;
    const showPerkCode = (perkCode && perkId === activePerkId) || lastRequestedCode;
    const codeToShow = perkId === activePerkId ? perkCode : lastRequestedCode;
    const isButtonDisabled =
    (eligible && !isCodeAvailable) ||
    (!eligible && planType !== 'free') ||
    onTrial;
    return (
      <div className="perk-container">
        <div className="perk-container__image" style={bgDesktopImgPath ? { backgroundImage: `url(${bgDesktopImgPath})` } : null} >
          <div className="perk-logo" style={logoImgPath ? { backgroundImage: `url(${logoImgPath})` } : null} />
          {eligible ? <div><div className="perk-discounttext">{discountText}</div></div> : null}
        </div>
        <div className="perk-container__details">
          <div className="perk-name">
            {!eligible ? <Lock /> : null}
            {name}
          </div>
          <div className="perk-description">{eligible ? description : freeDescription}</div>
          <div className="perkcode-container">
            {
              showPerkCode ?
                <div className="perkcode-lastrequested">
                  <div>{codeToShow}</div>
                </div> :
                <div className={getButtonClass(eligible, planType, isCodeAvailable)}>
                  <Button
                    loading={showLoading}
                    button={{ disabled: isButtonDisabled }}
                    onClick={() => this.handleButtonClick(perkId, eligible, planType)}
                  >
                    {getButtonText(planType, eligible, isCodeAvailable)}
                  </Button>
                </div>
            }
            {
              showPerkCode && partnerUrl ?
                <div className="perkcode-link-container">
                  <a className="perkcode-link" href={partnerUrl} target="_blank" rel="noopener noreferrer">
                    <div className="perkcode-partnerurl">
                      <span>Shop on {partnerUrl}</span>
                      <div>
                        <NewTab />
                      </div>
                    </div>
                  </a>
                </div>
                :
                null
            }
            {showError ? (
              <Alert type="error" style={{ marginBottom: '5px', textAlign: 'center' }} >
                {error}
              </Alert>
            ) : null}
          </div>
        </div>

      </div>
    );
  }
}
Perk.propTypes = {
  perk: PropTypes.shape({}),
  planType: PropTypes.string,
  selectedPerks: PropTypes.shape([]),
  submitting: PropTypes.bool,
  error: PropTypes.shape({}),
  subscription: PropTypes.shape({}),
};
Perk.defaultProps = {
  perk: null,
  planType: null,
  selectedPerks: null,
  submitting: false,
  error: null,
  subscription: null,
};

export default Perk;
